import React from 'react';
import styled from 'styled-components';
import {formElementSetup} from '../../../form-mixin/formElementSetup';
import {conditionDisable} from '../../../form-conditions/conditionDisable';
import {FormControlStructure} from '../../FormControlStructure';
import {innerContainerPrefix} from '../../../form-conditions/conditionPrefix';
import {innerContainerSuffix} from '../../../form-conditions/conditionSuffix';

export const InputWrapper = styled.div`
    ${formElementSetup}
    background: var(--form-control-background-color);
    border: 1px solid var(--form-control-border-color);
    ${({disabled}) => conditionDisable(disabled)};
    ${({suffix}) => innerContainerSuffix(suffix)};
    ${({prefix}) => innerContainerPrefix(prefix)};
`;

export const InputStructure = ({
    nonePrefix,
    name,
    disabled,
    label,
    prefix,
    suffix,
    styleFile,
    children,
    errorMessage,
}) => (
    <FormControlStructure
        nonePrefix={nonePrefix}
        styleFile={styleFile}
        label={label}
        name={name}
        errorMessage={errorMessage}
        prefix={prefix}
        suffix={suffix}
        disabled={disabled}>
        <InputWrapper disabled={disabled} suffix={suffix} prefix={prefix} autoFocus={true} tabindex="10">
            {children}
        </InputWrapper>
    </FormControlStructure>
);
